<template>
  <el-dialog title="当月可发放佣金流水" :visible.sync="dialogVisible" @close="$emit('update:visible',false)" width="70%">
    <div class="dialog_conwrap">
      <el-table
              :data="tableData"
              style="width: 100%">
        <el-table-column type="expand">
          <template slot-scope="props">
                <!--<span>{{ props.row.name }}</span>-->
                <el-table
                        :data="props.row.goods_list"
                        style="width: 100%">
                  <el-table-column
                          prop="date"
                          label="商品图片"
                          width="180">
                    <template slot-scope="scope">
                      <img :src="scope.row.goods_thumb" alt="" width="50" height="50">
                    </template>
                  </el-table-column>
                  <el-table-column
                          prop="goods_name"
                          label="商品名称"
                          width="180">
                  </el-table-column>
                  <el-table-column
                          label="单价/数量">
                    <template slot-scope="scope">
                      ￥{{scope.row.price}}*{{scope.row.number}}
                    </template>
                  </el-table-column>
                  <el-table-column
                          prop="commission"
                          label="员工佣金">
                  </el-table-column>
                  <el-table-column
                          prop="sale_discount"
                          label="单售后扣减数量">
                  </el-table-column>
                  <el-table-column
                          prop="dis_commission"
                          label="扣减佣金">
                  </el-table-column>
                </el-table>
          </template>
        </el-table-column>
        <el-table-column
                label="订单编号"
                prop="order_sn">
        </el-table-column>
        <el-table-column
                label="完成时间"
                prop="finish_time">
        </el-table-column>
        <el-table-column
                label="订单金额"
                prop="order_amount">
        </el-table-column>
        <el-table-column
                label="原佣金"
                prop="commission">
        </el-table-column>
        <el-table-column
                label="售后扣减"
                prop="dis_commission">
        </el-table-column>
        <el-table-column
                label="现佣金"
                prop="new_commission">
        </el-table-column>
      </el-table>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false" size="small">取 消</el-button>
      <el-button type="primary" @click="savePrograma" size="small">确 定</el-button>
    </span>
  </el-dialog>
</template>
<script>
  import api from "@/api.js";
  import { pagination} from "@/util/util.js";

  export default {
    name: "addColumnDialog",
    props: ["visible","employeeId"],
    watch: {
      visible() {
        this.dialogVisible = this.visible;
      }
    },
    data() {
      return {
        tableData: [],
        page: {
          pageindex: pagination.pageIndex,
          pagesize: pagination.pageSize,
          total: pagination.total
        },
        dialogVisible: this.visible,
      };
    },
    created() {
      this.savePrograma()
    },
    methods: {
      savePrograma() {
        this.axios
            .post(api.financial_employee_detail, {employee_id:this.employeeId})
            .then(response => {
              if (response.data.code == 0) {
                for(let i in response.data.list){
                  response.data.list[i].new_commission = response.data.list[i].commission - response.data.list[i].dis_commission
                }
                this.tableData = response.data.list
                this.page.total = response.data.all_page
              } else {
              }
            })
            .catch(response => {
            });
      }
    }
  };
</script>

